import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TooltipPosition, MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'lib-icon-button',
  imports: [MatTooltip],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent {
  // --- Inputs ---
  disabled = input<boolean>(false);
  imgActive = input<boolean | undefined>(undefined);
  activeImgSrc = input.required<string>();
  inactiveImgSrc = input.required<string>();
  altText = input.required<string>();

  // Tooltip configuration
  tooltipText = input<string>('');
  tooltipPosition = input<TooltipPosition>('above');
  tooltipDisabled = input<boolean>(false);
  tooltipCustomClass = input<string>('ag-grid-custom-tooltip');

  // Outputs
  actionClick = output<MouseEvent>();

  // Helper method for the template
  isImageActive() {
    return this.imgActive() === undefined ? !this.disabled() : this.imgActive();
  }

  onClick(event: MouseEvent) {
    if (!this.disabled()) {
      this.actionClick.emit(event);
    }
  }
}
